import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import MatchForm from './MatchForm';
import StatsWidget from './StatsWidget';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

const MatchPage = props => {
    let { state }= useLocation();
    const [formData, setFormData] = useState({});
    const [searchParams] = useSearchParams();
    const [defaultState, setDefaultState] = useState({});

    const onInputBlur = data => {
        setFormData(data);
    };

    const renderMatchingContent = () => {
        return (
            <div className="app__match-page__content">
                <div className="app__match-page__left">
                    <div className="match-page__widget">
                        <StatsWidget
                            formData={{ ...formData }}
                            data={state ? state : defaultState}
                            showButton={false}
                            isVertical={true}
                        />
                    </div>
                </div>
                <div className="app__match-page__right">
                    <div className="match-page__form">
                        <MatchForm onInputBlur={onInputBlur} state={state ? state : defaultState} />
                    </div>
                </div>
            </div>
        );
    };

    const renderBanner = () => {
        return (
            <div className="app__match-page__full-image match-page__image">
                <div className="opacity-layer">
                    <div className="app__match-page__title">
                        <h1 className="vouchedfor-brand">
                            Enter your details and a highly rated financial adviser will be in touch
                        </h1>
                        <div className="app__match-page__subtitle">
                            The first call will just be to explain how they can help; there is no
                            commitment!
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    useEffect(() => {
        if (!state) {
            let utm = searchParams.get('utm');
            let postcode = searchParams.get('postcode');
            setDefaultState ({
                adviceArea: 397,
                key: 'investment-and-pension',
                label: "Starting a pension or investment",
                utm: utm,
                postcode: postcode
            });
        }
    }, []);

    return (
        <div className="app__landing-page__section--full app__match-page__container">
            {renderBanner()}
            {renderMatchingContent()}
            <div className="app__match-page__subtitle">
                <p>Prefer to speak to us? Freephone 0330 038 8543</p>
            </div>
        </div>
    );
};

export default MatchPage;
